import { useGetList } from "react-admin";

function useVersions(enabled: boolean) {
  const { data = [], isLoading, ...rest } = useGetList("versions", undefined, {enabled});
  return {...rest, data, isLoading}
}

export default useVersions